import { render, staticRenderFns } from "./tabelasDetalhar.vue?vue&type=template&id=3b98ed32"
import script from "./tabelasDetalhar.vue?vue&type=script&lang=js"
export * from "./tabelasDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports